import {getRundschreibenAdmin} from './rundschreibenAdmin';

const axios = require('axios');
const $ = require('jquery');

import {ClassicEditor as ClassicEditorBase} from '@ckeditor/ckeditor5-editor-classic';
import {GeneralHtmlSupport} from '@ckeditor/ckeditor5-html-support';
import {Essentials} from '@ckeditor/ckeditor5-essentials';
import {Autoformat} from '@ckeditor/ckeditor5-autoformat';
import {Bold, Italic, Underline, Subscript, Superscript} from '@ckeditor/ckeditor5-basic-styles';
import {List} from '@ckeditor/ckeditor5-list';
import {Paragraph} from '@ckeditor/ckeditor5-paragraph';
import {Image, ImageCaption, ImageStyle, ImageToolbar, ImageUpload, ImageResizeEditing, ImageResizeButtons, ImageResizeHandles} from '@ckeditor/ckeditor5-image';
import {Base64UploadAdapter} from '@ckeditor/ckeditor5-upload';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import Cropper from 'cropperjs';

import Link from './ckeditor5-link/src/link';
import ClipboardJS from 'clipboard';

export default class ClassicEditor extends ClassicEditorBase {
}

ClassicEditor.builtinPlugins = [
  Base64UploadAdapter,
  Essentials,
  Autoformat,
  Bold,
  Italic,
  Underline,
  Subscript,
  Superscript,
  Link,
  List,
  Paragraph,
  Image,
  ImageCaption,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  ImageResizeButtons,
  ImageResizeEditing,
  ImageResizeHandles,
  //T3PageLink,
];

ClassicEditor.defaultConfig = {
  allowedContent: true,
  toolbar: {
    items: [
      'bold',
      'italic',
      'underline',
      'subscript',
      'superscript',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'link',
      'imageUpload',
    ],
    shouldNotGroupWhenFull: true,
  },
  licenseKey: 'GPL',
  language: 'de',
  image: {
    resizeOptions: [
      {
        name: 'resizeImage:original',
        value: null,
        icon: 'original',
      },
      {
        name: 'resizeImage:25',
        value: '25',
        icon: 'small',
      },
      {
        name: 'resizeImage:50',
        value: '50',
        icon: 'medium',
      },
      {
        name: 'resizeImage:75',
        value: '75',
        icon: 'large',
      },
    ],
    toolbar: [
      'imageTextAlternative',
      'toggleImageCaption',
      '|',
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      '|',
      'resizeImage:original',
    ],
  },
  link: {
    decorators: {
      customLink: {
        mode: 'manual',
        label: 'Keyword-Link',
        classes: 'sbr-keyword-link',
      },
    },
  },
};

/**
 * rundschreiben_getClick
 * @param element
 * @param overwriteBasePath
 */
window.rundschreiben_getClick = function(element, overwriteBasePath = '') {
  document.querySelectorAll(element).forEach(el => el.addEventListener('click', event => {
    const isCheckbox = event.target.closest('div').classList.contains('form-field--checkbox');
    const isMove = event.target.closest('div').classList.contains('move');
    const isNoClick = event.target.closest('div').classList.contains('no-click');

    if (!isCheckbox && !isMove && !isNoClick) {
      const row = event.target.closest(element);
      rundschreiben_openDetails(Number(row.getAttribute('data-id')), overwriteBasePath);
    }
  }));
};

/**
 * rundschreiben_openAdminDetails
 * @param id
 * @param overwriteBasePath
 */
window.rundschreiben_openDetails = function(id, overwriteBasePath = '') {
  window.location = (overwriteBasePath !== '' ? overwriteBasePath : BASE_PATH) + '?id=' + id + '&openRs';
};

/**
 * rundschreiben_selectForRead
 */
window.rundschreiben_selectForRead = function() {
  const inputSelectRundschreiben = document.querySelectorAll('.select-rundschreiben');
  const buttonSetAsRead = document.getElementById('editListData');

  buttonSetAsRead.setAttribute('disabled', 'disabled');

  let hasCheckedElements = false;
  inputSelectRundschreiben.forEach(function(element) {
    if (element.checked) {
      hasCheckedElements = true;
    }
  });

  if (hasCheckedElements === true) {
    buttonSetAsRead.removeAttribute('disabled');
  }
};

/**
 * Mark as read
 * @param setAll
 */
window.rundschreiben_markAsRead = function(setAll = false) {
  if (setAll) {
    // POST request
    axios.post(BASE_PATH + 'ajax/helper/setAsRead', window.object2FormData({
      'checkedAll': '1',
    })).then(function() {
      if (typeof ListRundschreiben !== 'undefined') {
        ListRundschreiben.updater();
      }
    });
  } else {
    const rundschreibenList = [];
    document.querySelectorAll('.select-rundschreiben').forEach(function(element) {
      if (element.checked) {
        rundschreibenList.push(element.value);
      }
    });

    // POST request
    axios.post(BASE_PATH + 'ajax/helper/setAsRead', window.object2FormData({
      rundschreibenList,
    })).then(function() {
      if (typeof ListRundschreiben !== 'undefined') {
        ListRundschreiben.updater();
      }
    });
  }
};

/**
 * Open culture dialog
 * @returns {boolean}
 */
window.rundschreiben_openCulture = function() {
  const cultureList = document.querySelectorAll('#culture-list');
  const selectedCultures = [];

  cultureList.forEach(function(culture) {
    const cultureInputs = culture.querySelectorAll('input.culture-id');
    cultureInputs.forEach(function(input) {
      selectedCultures.push(input.value);
    });
  });

  // isPAN
  const isPAN = document.getElementById('u[isPAN]');

  ajaxDialog(BASE_PATH + 'ajax/dialog/addCulture?selectedCultures=' + selectedCultures.join(',') + '&isPAN=' + (isPAN.checked ? 1 : 0), 450);
  return false;
};

/**
 * Add Culture
 * @param cultureID
 * @param cultureName
 * @param isPAN
 */
window.rundschreiben_addCulture = function(cultureID, cultureName, isPAN) {
  if (!document.querySelector('#culture-list .culture__item[data-culture-id="' + cultureID + '"]')) {
    const template = document.getElementById('culture-item').innerHTML;

    let newTemplate = template.replace(new RegExp('%CULTURE_ID%', 'g'), cultureID);
    newTemplate = newTemplate.replace(new RegExp('%CULTURE_NAME%', 'g'), cultureName);

    document.querySelector('#culture-list').insertAdjacentHTML('beforeend', newTemplate);

    // Ausnahmen
    const preparedCulture = document.querySelector('#culture-list');

    if (isPAN) {
      preparedCulture.querySelector('div[data-culture-id="' + cultureID + '"]').querySelector('div.zones').remove();
      preparedCulture.querySelector('div[data-culture-id="' + cultureID + '"]').querySelector('div.korres-element').remove();
    } else {
      // Nur bei Fläche "Verwaltung die Zone "Fläche" anzeigen
      if (parseInt(cultureID) !== 10) {
        // zoneID === 13 => remove
        preparedCulture.querySelector('div[data-culture-id="' + cultureID + '"]').querySelector('div[data-zn-id="13"]').remove();
      }

      // Bei Fläche "Verwaltung" nur Zone "Verwaltung" anzeigen (und wieder raus..)
      if (parseInt(cultureID) === 10) {
        // zoneID !== 13 => remove
        preparedCulture.querySelector('div[data-culture-id="' + cultureID + '"]').querySelectorAll('div[data-zn-id]:not([data-zn-id="13"])').forEach(el => el.remove());
      }
    }
  }
};

/**
 * Delete Culture
 * @param allSelectedCultures
 */
window.rundschreiben_deleteCulture = function(allSelectedCultures) {
  const selectedCultures = allSelectedCultures.split(',');
  if (document.querySelectorAll('#culture-list .culture__item[data-culture-id]')) {
    document.querySelectorAll('#culture-list .culture__item[data-culture-id]').forEach(item => {
      const cultureID = item.getAttribute('data-culture-id');
      if (!selectedCultures.includes(cultureID)) {
        // Wenn nicht vorhanden, Element entfernen
        item.remove();
      }
    });
  }
};

/**
 * Select all zones
 * @param element
 * @param kulturID
 */
window.rundschreiben_selectAllZones = function(element, kulturID) {
  if ($(element).is(':checked')) {
    $(element).closest('.zones').find('.zone-line').find('input').prop('checked', true);
    $(element).closest('.zones').find('.all-sub-selector').prop('checked', true);
    $(element).closest('.zones').find('.subzone-line.ist-ort').find('input').prop('checked', true);
    $('div.subzone[data-kultur="' + kulturID + '"]').show();
  } else {
    $(element).closest('.zones').find('.zone-line').find('input').prop('checked', false);
    $(element).closest('.zones').find('.all-sub-selector').prop('checked', false);
    $(element).closest('.zones').find('.subzone-line').find('input').prop('checked', false);
    $('div.subzone[data-kultur="' + kulturID + '"]').hide();
  }
};

/**
 * Show sub-zones
 * @param element
 * @param kulturID
 */
window.rundschreiben_showSubZone = function(element, kulturID) {
  var zoneID = $(element).val();
  if ($(element).is(':checked')) {
    $(element).closest('div[data-zn-id]').find('div.subzone[data-zone="' + zoneID + '"][data-kultur="' + kulturID + '"]').show();
    $(element).closest('div[data-zn-id]').find('div.subzone[data-zone="' + zoneID + '"][data-kultur="' + kulturID + '"] .subzone-line.ist-ort input').prop('checked', true);
  } else {
    $(element).closest('div[data-zn-id]').find('div.subzone[data-zone="' + zoneID + '"][data-kultur="' + kulturID + '"]').find('input').prop('checked', false);
    $(element).closest('div[data-zn-id]').find('div.subzone[data-zone="' + zoneID + '"][data-kultur="' + kulturID + '"]').hide();
  }

  rundschreiben_checkSelectAll();
};

/**
 * Select all sub-zones
 * @param element
 */
window.rundschreiben_selectAllSubZones = function(element) {
  if ($(element).is(':checked')) {
    $(element).closest('.subzone').find('.subzone-line.ist-ort').find('input').prop('checked', true);
  } else {
    $(element).closest('.subzone').find('.subzone-line').find('input').prop('checked', false);
  }
};

/**
 * Check Select All
 */
window.rundschreiben_checkSelectAll = function() {
  $('div.zones').each(function() {
    // Subzonen
    $(this).find('div.subzone:visible').each(function() {
      var selectedSubAll = true;
      if ($(this).find('input.ist-input-ort:not(.all-sub-selector)').length > 0) {
        $(this).find('input.ist-input-ort:not(.all-sub-selector)').each(function() {
          if (!$(this).is(':checked')) {
            selectedSubAll = false;
          }
        });

        if (selectedSubAll === true) {
          $(this).find('input.all-sub-selector').prop('checked', true);
        } else {
          $(this).find('input.all-sub-selector').prop('checked', false);
        }
      }
    });

    // Zonen
    var selectedAll = true;
    $(this).find('div.zone-line:visible').each(function() {
      if ($(this).closest('div[data-zn-id]').find('input.ist-input-ort:not(.all-selector):not(.all-sub-selector)').length > 0) {
        $(this).closest('div[data-zn-id]').find('input.ist-input-ort:not(.all-selector):not(.all-sub-selector)').each(function() {
          if (!$(this).is(':checked')) {
            selectedAll = false;
          }
        });
      }
    });

    if ($(this).find('input.ist-input-ort:not(.all-selector):not(.all-sub-selector):checked').length > 0 && selectedAll === true) {
      $(this).closest('div.zones').find('input.all-selector').prop('checked', true);
    } else {
      $(this).closest('div.zones').find('input.all-selector').prop('checked', false);
    }
  });
};

/**
 * Remove culture
 * @param element
 */
window.rundschreiben_removeCulture = function(element) {
  element.closest('div.culture__item').remove();
};

/**
 * Check selected picture(s)
 */
window.rundschreibenSelectedPictures = function() {
  const selectedMultiplePictures = document.getElementById('selected-multiple-pictures');
  const selectedSinglePicture = document.getElementById('selected-single-pictures');

  if (selectedMultiplePictures) {
    const allSelected = selectedMultiplePictures.querySelectorAll('.chip input[type="hidden"]');
    allSelected.forEach(function(input) {
      const value = input.value;
      const checkboxes = document.querySelectorAll('#photo-list input[name="selected-multiple-pictures"][value="' + value + '"]');
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = true;
      });
    });
  } else if (selectedSinglePicture) {
    const selected = selectedSinglePicture.value;
    if (selected !== '') {
      const checkbox = document.querySelector('#photo-list input[name="selected-picture"][value="' + selected + '"]');
      if (checkbox) {
        checkbox.checked = true;
      }
    }
  }
};

/**
 * Select picture
 * @param element
 * @param multiple
 */
window.rundschreiben_selectPicture = function(element, multiple = false) {
  const pictureValue = element.value;

  let selectedContainer;
  if (multiple === true) {
    selectedContainer = document.getElementById('selected-multiple-pictures');
  } else {
    selectedContainer = document.getElementById('selected-single-pictures');
    selectedContainer.innerHTML = '';
  }

  if (element.checked) {
    const selectedSpan = document.createElement('span');
    selectedSpan.className = 'chip';

    const spanText = document.createElement('span');
    spanText.textContent = 'ID - ' + pictureValue;
    selectedSpan.appendChild(spanText);

    const removeIcon = document.createElement('i');
    removeIcon.className = 'material-icons hand remove-chip';
    removeIcon.textContent = 'cancel';
    removeIcon.onclick = function() {
      selectedContainer.removeChild(selectedSpan);
      if (typeof ListFotothek !== 'undefined') {
        ListFotothek.updater();
      }
    };
    selectedSpan.appendChild(removeIcon);

    const hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    if (multiple === true) {
      hiddenInput.setAttribute('name', 'u[selectedPictures][]');
    } else {
      hiddenInput.setAttribute('name', 'u[selectedPictures]');
    }
    hiddenInput.setAttribute('value', pictureValue);
    selectedSpan.appendChild(hiddenInput);

    selectedContainer.appendChild(selectedSpan);
  } else if (multiple === true) {
    const chips = selectedContainer.getElementsByClassName('chip');
    for (let i = 0; i < chips.length; i++) {
      const chipValue = chips[i].getElementsByTagName('input')[0].value;
      if (chipValue === pictureValue) {
        selectedContainer.removeChild(chips[i]);
        break;
      }
    }
  }
};

/**
 * Reload all areas
 */
window.rundschreiben_details_reloadAllAreas = function() {
  // Loader anzeigen
  autoLoaderV2('.js--rundschreiben-ajax-content-area');
  autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');
  autoLoaderV2('.js--rundschreiben-ajax-status-area');

  // import refresh functions and execute
  import('./rundschreibenAdmin.js').then(({refreshContentArea, refreshEditBlockArea, refreshStatusArea}) => {
    refreshContentArea();
    refreshEditBlockArea();
    refreshStatusArea();
  });
};

/**
 * initRundschreibenCropper
 * @param container
 */
window.initRundschreibenCropper = function(container) {
  var containerElement = document.querySelector(container);
  if (containerElement) {
    var cropinput = document.querySelector('#cropinput');
    var dataStartcrop = JSON.parse(containerElement.dataset.startcrop);
    var startAspectRatio = containerElement.dataset.startaspectratio;
    if (startAspectRatio !== 'NaN') {
      startAspectRatio = parseFloat(startAspectRatio);
    }

    // parse all values to int
    for (var key in dataStartcrop) {
      if (Object.prototype.hasOwnProperty.call(dataStartcrop, key)) {
        dataStartcrop[key] = parseInt(dataStartcrop[key]);
      }
    }

    var image = containerElement.querySelector('.js--rundschreiben-cropper-image:not(.cropper-hidden)');
    var actions = containerElement.querySelector('.js--rundschreiben-cropper-actions');

    var options = {
      aspectRatio: startAspectRatio,
      movable: false,
      rotatable: false,
      scalable: false,
      zoomable: false,
      zoomOnTouch: false,
      zoomOnWheel: false,
      data: dataStartcrop,
      // preview: '.img-preview',
      ready: function(e) {
        // console.log(e.type);
      },
      cropstart: function(e) {
        // console.log(e.type, e.detail.action);
      },
      cropmove: function(e) {
        // console.log(e.type, e.detail.action);
      },
      cropend: function(e) {
        // console.log(e.type, e.detail.action);
      },
      crop: function(e) {
        var data = e.detail;

        const getData = cropper.getData();
        cropinput.value = JSON.stringify(getData);
      },
      zoom: function(e) {
        // console.log(e.type, e.detail.ratio);
      },
    };

    var cropper = new Cropper(image, options);

    // Options
    if (actions) {
      actions.querySelector('.docs-toggles').onchange = function(event) {
        var e = event || window.event;
        var target = e.target || e.srcElement;
        var cropBoxData;
        var canvasData;
        var isCheckbox;
        var isRadio;

        if (!cropper) {
          return;
        }

        if (target.tagName.toLowerCase() === 'label') {
          target = target.querySelector('input');
        }

        isCheckbox = target.type === 'checkbox';
        isRadio = target.type === 'radio';

        if (isCheckbox || isRadio) {
          if (isCheckbox) {
            options[target.name] = target.checked;
            cropBoxData = cropper.getCropBoxData();
            canvasData = cropper.getCanvasData();

            options.ready = function() {
              cropper.setCropBoxData(cropBoxData).setCanvasData(canvasData);
            };
          } else {
            options[target.name] = target.value;
            options.ready = function() {
              // console.log('ready');
            };

            // remove active class from inputs with same name
            document.querySelectorAll('.docs-toggles input[name="' + target.name + '"]').forEach(el => el.parentElement.classList.remove('active'));
            // add active class to current input
            target.parentElement.classList.add('active');
          }

          // Restart
          cropper.destroy();
          cropper = new Cropper(image, options);
        }
      };

      // Methods
      actions.querySelector('.docs-buttons').onclick = function(event) {
        var e = event || window.event;
        var target = e.target || e.srcElement;
        var cropped;
        var result;
        var input;
        var data;

        if (!cropper) {
          return;
        }

        while (target !== this) {
          if (target.getAttribute('data-method')) {
            break;
          }

          target = target.parentNode;
        }

        if (target === this || target.disabled || target.className.indexOf('disabled') > -1) {
          return;
        }

        data = {
          method: target.getAttribute('data-method'),
          target: target.getAttribute('data-target'),
          option: target.getAttribute('data-option') || undefined,
          secondOption: target.getAttribute('data-second-option') || undefined,
        };

        cropped = cropper.cropped;

        if (data.method) {
          if (typeof data.target !== 'undefined') {
            input = document.querySelector(data.target);

            if (!target.hasAttribute('data-option') && data.target && input) {
              try {
                data.option = JSON.parse(input.value);
              } catch (e) {
                console.log(e.message);
              }
            }
          }

          switch (data.method) {
            case 'clear':
              // cropper.clear();

              // set aspect ratio to free
              options['aspectRatio'] = 'NaN';

              options['ready'] = () => {
                // set crop box data to full height and width
                var contData = cropper.getImageData(); //Get container data
                cropper.setCropBoxData({x: 0, y: 0, height: contData.height, width: contData.width}); //set data

                // remove all active classes from .docs-toggles input radios with name aspectRatio
                document.querySelectorAll('.docs-toggles input[name="aspectRatio"]').forEach(el => el.parentElement.classList.remove('active'));
                // add active class to input radio with value NaN
                document.querySelector('.docs-toggles input[name="aspectRatio"][value="NaN"]').parentElement.classList.add('active');
              };

              // Restart
              cropper.destroy();
              cropper = new Cropper(image, options);

              break;
            case 'reset':
              cropper.reset();
              break;
            case 'rotate':
              if (cropped && options.viewMode > 0) {
                cropper.clear();
              }

              break;

            case 'getCroppedCanvas':
              try {
                data.option = JSON.parse(data.option);
              } catch (e) {
                console.log(e.message);
              }

              if (uploadedImageType === 'image/jpeg') {
                if (!data.option) {
                  data.option = {};
                }

                data.option.fillColor = '#fff';
              }

              break;
          }

          result = cropper[data.method](data.option, data.secondOption);

          switch (data.method) {
            case 'rotate':
              if (cropped && options.viewMode > 0) {
                cropper.crop();
              }

              break;

            case 'scaleX':
            case 'scaleY':
              target.setAttribute('data-option', -data.option);
              break;

            case 'getCroppedCanvas':
              if (result) {
                // Bootstrap's Modal
                $('#getCroppedCanvasModal').modal().find('.modal-body').html(result);

                if (!download.disabled) {
                  download.download = uploadedImageName;
                  download.href = result.toDataURL(uploadedImageType);
                }
              }

              break;

            case 'destroy':
              cropper = null;

              if (uploadedImageURL) {
                URL.revokeObjectURL(uploadedImageURL);
                uploadedImageURL = '';
                image.src = originalImageURL;
              }

              break;
          }

          if (typeof result === 'object' && result !== cropper && input) {
            try {
              input.value = JSON.stringify(result);
            } catch (e) {
              console.log(e.message);
            }
          }
        }
      };
    }
  }
};

// check for changes during rundschreiben details editing
window.rundschreiben_details_checkChanges = function() {
  // if .rundschreiben-admin exists
  const rundschreibenAdmin = document.querySelector('.rundschreiben-admin');
  if (rundschreibenAdmin) {
    import('./rundschreibenAdmin.js').then(({getRundschreibenAdmin}) => {
      // Deine Request-Logik hier
      return axios.get(BASE_PATH + 'ajax/helper/checkChanges', {
        params: {
          ajax: 1,
          id: getRundschreibenAdmin(),
        },
      }).then(response => {
        if (response.data === true) {
          // open dialog to inform user that somebody else has edited this entry
          ajaxDialog(BASE_PATH + 'ajax/dialog/reloadForExternalChanges?id=' + getRundschreibenAdmin(), 450);
        } else {
          // recall function after 30 seconds
          setTimeout(rundschreiben_details_checkChanges, 30000);
        }
      }).catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request abort:', error.message);
        } else {
          console.error('Error: ', error.message);
        }
      });
    });
  }
};

/**
 * Reset the filter inputs to their default values.
 * This function clears the values of specific filter-related input fields
 * and sets the reset filter flag to '1'.
 */
window.resetFilter = function() {
    document.getElementById('reset-filter-input').value = '1';
    document.getElementById('fullsearch-search').value = '';
    document.getElementById('fullsearch-datefrom').value = '';
    document.getElementById('fullsearch-dateto').value = '';
};

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', function() {
  // remove openRs parameter from URL but keep all other parameters
  if (window.location.search.includes('openRs')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('openRs');
    window.history.replaceState({}, document.title, url);
  }

  // check for changes during rundschreiben details editing
  rundschreiben_details_checkChanges();

  function convertKeysToNestedObject(obj) {
    const result = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const keys = key.split(/\[|\]/).filter(Boolean);

        let currentLevel = result;
        for (let i = 0; i < keys.length; i++) {
          const currentKey = keys[i];
          if (!currentLevel[currentKey]) {
            if (i === keys.length - 1) {
              currentLevel[currentKey] = obj[key];
            } else {
              currentLevel[currentKey] = {};
            }
          }
          currentLevel = currentLevel[currentKey];
        }
      }
    }

    return result;
  }

  // timeout for live preview
  let onInputTimeoutID;

  // add block button
  bubbleEvent('.js--rundschreiben-add-block', 'click', function(event) {
    const el = event.target;
    const type = el.getAttribute('data-type');
    const position = el.getAttribute('data-position');

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({addBlock}) => {
      addBlock(type, position);
    });
  });
  // remove block button
  bubbleEvent('.js--rundschreiben-remove-block', 'click', function(event) {
    const el = event.target;
    const position = el.getAttribute('data-position');

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({removeBlock}) => {
      removeBlock(position);
    });
  });
  // move block button
  bubbleEvent('.js--rundschreiben-move-block', 'click', function(event) {
    const el = event.target;
    const oldPosition = el.getAttribute('data-oldposition');
    const position = el.getAttribute('data-position');

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({moveBlock}) => {
      moveBlock(oldPosition, position);
    });
  });
  // start edit button
  bubbleEvent('.js--rundschreiben-start-edit-block', 'click', function(event) {
    const el = event.target;
    const position = el.getAttribute('data-position');

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({startEditBlock}) => {
      startEditBlock(position);
    });
  });
  // end edit button
  bubbleEvent('.js--rundschreiben-end-edit-block', 'click', function() {
    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({endEditBlock}) => {
      endEditBlock();
    });
  });
  // remove hero image
  bubbleEvent('.js--rundschreiben-delete-heroimage', 'click', function() {
    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');

    import('./rundschreibenAdmin.js').then(({removeHeroImage}) => {
      removeHeroImage();
    });
  });
  // remove file button
  bubbleEvent('.js--rundschreiben-remove-file', 'click', function(event) {
    const el = event.target;
    const position = el.getAttribute('data-position');
    const name = el.getAttribute('data-name');
    const file = el.getAttribute('data-file');

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');
    autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

    import('./rundschreibenAdmin.js').then(({removeFile}) => {
      removeFile(position, name, file);
    });
  });

  // on input live session update
  bubbleEvent('.js--rundschreiben-ajax-edit-content-area input, .js--rundschreiben-ajax-edit-content-area select, .js--rundschreiben-ajax-edit-content-area textarea', 'input', function(event) {
    const el = event.target;
    const name = el.getAttribute('name');

    // get data position from closest .block-form
    const position = el.closest('.block-form').getAttribute('data-position');

    // get values from all inputs, selects and textareas in this block-form
    const data = {};
    el.closest('.block-form').querySelectorAll('input, select, textarea').forEach(el => {
      const name = el.getAttribute('name');
      const type = el.getAttribute('type');
      if (typeof type !== 'undefined' && type === 'checkbox') {
        data[name] = el.checked ? 1 : 0;
      } else {
        data[name] = el.value;
      }
    });

    // data from ckeditors
    el.closest('.block-form').querySelectorAll('.ck-editor__editable').forEach(el => {
      // get closest .ck-editor
      const ckeditor = el.closest('.ck-editor');
      // get previous element with name
      const name = ckeditor.previousElementSibling.getAttribute('name');
      data[name] = el.innerHTML;
    });

    const manipulatedData = convertKeysToNestedObject(data);

    if (name === 'type') {
      const finalData = manipulatedData.type;

      // Loader anzeigen
      autoLoaderV2('.js--rundschreiben-ajax-content-area');
      autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

      import('./rundschreibenAdmin.js').then(({editBlockType}) => {
        editBlockType(finalData, position);
      });
    } else {
      const finalData = manipulatedData.data;

      clearTimeout(onInputTimeoutID);

      onInputTimeoutID = setTimeout(function() {
        // Loader anzeigen
        autoLoaderV2('.js--rundschreiben-ajax-content-area');

        import('./rundschreibenAdmin.js').then(({editBlock}) => {
          editBlock(finalData, position);
        });
      }, 1000);
    }
  });

  // close open edit on click in area
  bubbleEvent('.js--rundschreiben-click-close-open-edit', 'click', function(event) {
    const el = event.target;
    const rundschreibenAdmin = document.querySelector('.rundschreiben-admin');
    const contentEditArea = document.querySelector('.js--rundschreiben-ajax-edit-content-area');

    const allowedTargetsByClassContains = [
      'js--rundschreiben-click-close-open-edit',
      'rundschreiben__content',
      'rundschreiben__footer',
    ];
    const targetIsAllowed = allowedTargetsByClassContains.some(className => el.classList.contains(className));

    // if target is event element
    if (targetIsAllowed && rundschreibenAdmin && contentEditArea && rundschreibenAdmin.classList.contains('show-editsidebar')) {
      // Loader anzeigen
      autoLoaderV2('.js--rundschreiben-ajax-content-area');
      autoLoaderV2('.js--rundschreiben-ajax-edit-content-area');

      import('./rundschreibenAdmin.js').then(({endEditBlock}) => {
        endEditBlock();
      });
    }
  });

  /**
   * initRundschreibenGallerySwiper
   */
  function initRundschreibenGallerySwiper() {
    /*document.querySelectorAll('.swiper.js--gallery-swiper').forEach(el => {
      const rundschreibenGallerySwiper = new Swiper(el, {
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: el.document.querySelector('.swiper-button-next'),
          prevEl: el.document.querySelector('.swiper-button-prev'),
        },
        modules: [Navigation],
      });
    });*/
    new Swiper('.js--gallery-swiper:not(.swiper-initialized)', {
      modules: [Navigation],
      direction: 'horizontal',
      loop: false,
      allowTouchMove: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Default parameters
      slidesPerView: 2,
      spaceBetween: 10,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 480px
        650: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }

  /**
   * updateContentByRTE
   * @param editor
   */
  function updateContentByRTE(editor) {
    const sourceElement = editor.sourceElement;
    const sourceElementName = sourceElement.getAttribute('name');
    // get content between data[ and ]
    const pureSourceElementName = sourceElementName.substring(sourceElementName.indexOf('[') + 1, sourceElementName.indexOf(']'));
    const editorData = editor.getData();

    // get data position from closest .block-form
    const position = sourceElement.closest('.block-form').getAttribute('data-position');

    // get values from all inputs, selects and textareas in this block-form
    const data = {};
    sourceElement.closest('.block-form').querySelectorAll('input, select, textarea').forEach(el => {
      const name = el.getAttribute('name');
      data[name] = el.value;
    });

    const manipulatedData = convertKeysToNestedObject(data);

    const finalData = manipulatedData.data;

    // add editorData to finalData
    finalData[pureSourceElementName] = editorData;

    // Loader anzeigen
    autoLoaderV2('.js--rundschreiben-ajax-content-area');

    import('./rundschreibenAdmin.js').then(({editBlock}) => {
      editBlock(finalData, position);
    });
  }

  // Selector für das gewünschte Element
  const targetSelector = '.js--rundschreiben-ajax-edit-content-area [data-rte="true"]';

  // Observer-Konfiguration
  const observerConfig = {
    childList: true, // Überwacht Änderungen an der direkten Kinderliste
    subtree: true,   // Überwacht Änderungen im gesamten Unterbaum
  };

  /**
   * Callback für MutationObserver
   * @param mutationsList
   * @param observer
   */
  function handleMutation(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Überprüfe hinzugefügte Nodes auf Übereinstimmung mit dem Selector
        mutation.addedNodes.forEach(node => {
          if (node && node.nodeType && node.nodeType === 1) {
            initRundschreibenGallerySwiper();

            const targetRTEs = node.querySelectorAll(targetSelector);
            if (targetRTEs) {
              targetRTEs.forEach(targetRTE => {
                // Entferne den Observer, da er nicht mehr benötigt wird
                //observer.disconnect();
                ClassicEditor.create(targetRTE).then(editor => {
                  editor.model.document.on('change:data', () => {
                    clearTimeout(onInputTimeoutID);

                    onInputTimeoutID = setTimeout(function() {
                      updateContentByRTE(editor);
                    }, 1000);
                  });
                }).catch(error => {
                  console.error(error);
                });
              });
            }
          }
        });
      }
    }
  }

  // Erstelle den Observer und starte die Überwachung
  const observer = new MutationObserver(handleMutation);
  observer.observe(document.body, observerConfig);

  initRundschreibenGallerySwiper();

  const elementsRTEs = document.querySelectorAll(targetSelector);
  if (elementsRTEs) {
    elementsRTEs.forEach(elementRTE => {
      if (!elementRTE.classList.contains('ql-container')) {
        ClassicEditor.create(elementRTE).then(editor => {
          editor.model.document.on('change:data', () => {
            clearTimeout(onInputTimeoutID);

            onInputTimeoutID = setTimeout(function() {
              updateContentByRTE(editor);
            }, 1000);
          });
        }).catch(error => {
          console.error(error);
        });
      }
    });
  }
});

var unloadEvent = function(e) {
  if (!document.querySelector('.modal') && document.getElementById('rundschreiben-diff') && e.target.activeElement.type !== 'submit' && e.target.activeElement.id !== 'button-save-and-close') {
    if (e && e.type === 'click' && e.target && e.target.type === 'submit') {
      return; // Keine Warnung anzeigen, wenn der Button ein "submit" Button ist
    }

    var confirmationMessage = 'Warnung: Deine Änderungen werden eventuell nicht gespeichert.';
    (e || window.e).returnValue = confirmationMessage;
    return confirmationMessage;
  }
};
window.addEventListener('beforeunload', unloadEvent);
